import { SelectV2, SelectV2Option } from '@cimplico/components';
import { Controller, useFormContext } from 'react-hook-form';
import { OnboardingXeroEntities } from './XeroEntitiesForm';
import { useState } from 'react';

type ExistingEntitiesSelectProps = {
    index: number;
    entitiesOptions: SelectV2Option[];
};

function ExistingEntitiesSelect({ index, entitiesOptions }: ExistingEntitiesSelectProps): JSX.Element {
    const [entitiesSearch, setEntitiesSearch] = useState('');

    const { getValues, formState } = useFormContext<OnboardingXeroEntities>();

    const connection = getValues(`connections.${index}`);

    return (
        <Controller
            name={`connections.${index}.entityId`}
            render={({ field: { onChange } }): JSX.Element => (
                <SelectV2
                    placeholder="Select an existing entity to integrate with..."
                    keepSelectedOptions
                    disabled={formState.isSubmitting}
                    size="small"
                    value={connection.entityId ? entitiesOptions.filter((e) => e.value === connection.entityId) : []}
                    onSearch={setEntitiesSearch}
                    options={entitiesOptions.filter((ent) => ent.label.toLowerCase().includes(entitiesSearch.toLowerCase()))}
                    onChange={(value): void => {
                        onChange(value.length === 1 ? (value[0].value as string) : undefined);
                    }}
                />
            )}
        />
    );
}

export default ExistingEntitiesSelect;
